// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3cXYj","upload":"Small_upload__2GvYi","imageWrap":"Small_imageWrap__1gwzP","removeBtn":"Small_removeBtn__2Ktio"};